module.exports = __webpack_public_path__ + "assets/arrow-tl-br.0a6e5a58.svg";